import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransformations_ds_get_hardallocationdetails_by_inventorytransformationsourcelineidService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { inventory_transformation_source_line_id: number }): 
  Promise<{ result: { Id?: number, InventoryTransformationSourceLineId?: number, LicensePlateId?: number, SerialNumberId?: number, Details?: { Id?: number, LotId?: number, PackagedAmount?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventory_transformation_source_line_id)) {
      missingRequiredInParams.push('\'inventory_transformation_source_line_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_get_hardallocationdetails_by_inventorytransformationsourcelineid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { inventory_transformation_source_line_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, InventoryTransformationSourceLineId?: number, LicensePlateId?: number, SerialNumberId?: number, Details?: { Id?: number, LotId?: number, PackagedAmount?: number }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventory_transformation_source_line_id)) {
      missingRequiredInParams.push('\'inventory_transformation_source_line_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_get_hardallocationdetails_by_inventorytransformationsourcelineid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { inventory_transformation_source_line_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, InventoryTransformationSourceLineId?: number, LicensePlateId?: number, SerialNumberId?: number, Details?: { Id?: number, LotId?: number, PackagedAmount?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventory_transformation_source_line_id)) {
      missingRequiredInParams.push('\'inventory_transformation_source_line_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_get_hardallocationdetails_by_inventorytransformationsourcelineid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      inventory_transformation_source_line_id: number    }) {
        if(isNil(inParams.inventory_transformation_source_line_id)) {
          return true; 
        }
      return false;
    }
}
